import React from 'react';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import NumericInput from 'react-numeric-input';
import { run } from '~/actions/recipe';
import { getStock } from '~/actions/rawMaterial';
import LocationPicker from '~/components/LocationPicker';
import ContainerPicker from '~/components/ContainerPicker';
import OrPicker from '~/components/OrPicker';
import Tag from '~/components/Tag';
import styleDialog from '~/style/dialog.scss';
import styleLocal from './style.scss';

const LocationOrContainerPicker = OrPicker({
  location: LocationPicker,
  container: ContainerPicker
});

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      runs: 1
    };
  }

  submit() {
    run(
      this.props.dispatch,
      this.context.apiClient,
      this.props.data.recipe.id,
      this.state.runs,
      this.state.fromLocation,
      this.state.toLocation,
    ).then(() => this.context.dialogClose(this.props.dialogId));
  }

  renderContent() {
    const { recipe } = this.props.data;
    const { rawMaterialStock, rawMaterials } = this.props;
    const ingredients = recipe.materials.map(m => {
      let s;
      let r;

      if (this.state.fromLocation) {
        s = rawMaterialStock.getIn([
          `${this.state.fromLocation.type}_${this.state.fromLocation.id}_${m.id}`
        ]);
        if (s) {
          s = s.toJS();
        }
      }

      r = rawMaterials.getIn([m.id]);
      if (r) {
        r = r.toJS();
      }

      return {
        id: m.id,
        needed: m.count,
        instock: s ? s.count : 0,
        delta: (s ? s.count : 0) - m.count,
        type: r.type
      };
    });
    return (
      <form
        onSubmit={e => {
          e.preventDefault();
          this.submit();
        }}
      >
        <div style={{ fontWeight: 'bold' }}>Run a production</div>
        <span>From&nbsp;</span>
        <LocationOrContainerPicker
          value={this.state.fromLocation}
          onChange={fromLocation => {
            this.setState({ fromLocation });
            if (fromLocation) {
              getStock(this.props.dispatch, this.context.apiClient, fromLocation);
            }
          }}
        />
        <br />
        <span>To&nbsp;</span>
        <LocationOrContainerPicker
          value={this.state.toLocation}
          onChange={toLocation => this.setState({ toLocation })}
        />
        <div className={styleLocal.subTitle}>{recipe.name}</div>
        <div className={styleLocal.row}>
          <div className={styleLocal.name}>Production runs</div>
          <div className={styleLocal.unit}>
            <NumericInput
              step={1}
              min={1}
              snap
              required
              value={this.state.runs}
              onChange={v => this.setState({ runs: v })}
            />
          </div>
        </div>
        <div className={styleLocal.subTitle}>Material required</div>
        {ingredients.map(ingredient => {
          const sumNeeded = ingredient.needed * this.state.runs;
          return (
            <div key={ingredient.id} className={styleLocal.row}>
              <Tag type="rawMaterial" id={ingredient.id} />
              <div className={styleLocal.unit}>
                {sumNeeded}&nbsp;{ingredient.type}
              </div>
              {(ingredient.instock - (ingredient.needed * this.state.runs)) < 0 && (
                <div className={styleLocal.ingredientError}>
                  There is not enough materials to produce. Currently in stock:
                  &nbsp;{ingredient.instock}&nbsp;{ingredient.type}
                </div>
              )}
            </div>
          );
        })}
        <div className={styleLocal.subTitle}>Will produce</div>
        {recipe.articles.map(article => (
          <div key={article.id} className={styleLocal.row}>
            <Tag type="article" id={article.id} />
            <div className={styleLocal.unit}>
              <span>x&nbsp;{article.count * this.state.runs}</span>
            </div>
          </div>
        ))}
        <Button label="Run production" type="submit" primary raised style={{ marginTop: 10 }} />
      </form>
    );
  }

  render() {
    return (
      <div
        className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')}
        onClick={() => this.context.dialogClose(this.props.dialogId)}
      >
        <div className={styleDialog.container} onClick={e => e.stopPropagation()} style={{ minWidth: '600px' }}>
          <IconButton
            className={styleDialog.closeButton}
            icon="close"
            onClick={() => this.context.dialogClose(this.props.dialogId)}
          />
          <div className={styleDialog.content}>{this.renderContent()}</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  rawMaterials: state.getIn(['rawMaterial', 'items']),
  rawMaterialStock: state.getIn(['rawMaterialStock', 'items'])
});

export default connect(mapStateToProps)(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/Produce/index.js